import { render } from "./PageListarHorarioAtendimento.vue?vue&type=template&id=28a408dc"
import script from "./PageListarHorarioAtendimento.vue?vue&type=script&lang=js"
export * from "./PageListarHorarioAtendimento.vue?vue&type=script&lang=js"

import "./PageListarHorarioAtendimento.vue?vue&type=style&index=0&id=28a408dc&lang=css"
/* custom blocks */
import block0 from "./PageListarHorarioAtendimento.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__